import * as React from "react";
import { DialogStateProvider } from "./dialog-state.js";
const defaultComponentFactory = (isOpen) => {
  const Component = (props) => {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, isOpen && props.children);
  };
  return Component;
};
const defaults = {
  useDialogControl: (id, dialogQueryKey, isOpen, setIsOpen) => {
    return {
      ComponentFactory: defaultComponentFactory(isOpen),
      actions: {
        openDialog: () => setIsOpen(true),
        closeDialog: () => setIsOpen(false),
        toggleDialog: () => setIsOpen(!isOpen)
      }
    };
  }
};
export const DialogControlContext = React.createContext(defaults);
export const DialogControlProvider = ({ value, children }) => {
  return /* @__PURE__ */ React.createElement(DialogStateProvider, null, /* @__PURE__ */ React.createElement(DialogControlContext.Provider, { value }, children));
};
